import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { savedMethod: String }
  static targets = [
    "method",
    "phoneOptions",
    "phoneTime",
    "phoneTimeNote",
    "date",
    "dateInputs",
    "selectedDates",
    "addDateButton",
    "lineAction",
    "lineButton",
    "lineDirect"
  ]

  connect() {
    this.sync()
    this.refreshDates()
  }

  sync() {
    const selectedMethod = this.methodTargets.find((input) => input.checked)?.value
    const phoneSelected = selectedMethod === "phone"
    const lineSelected = selectedMethod === "line"

    this.phoneOptionsTarget.hidden = !phoneSelected
    this.phoneOptionsTarget.setAttribute("aria-hidden", String(!phoneSelected))

    this.phoneTimeTargets.forEach((input) => {
      input.disabled = !phoneSelected
    })
    this.dateTargets.forEach((input) => {
      input.disabled = !phoneSelected
    })
    this.phoneTimeNoteTarget.disabled = !phoneSelected

    if (this.hasLineActionTarget) {
      this.lineActionTarget.classList.toggle("is-visible", lineSelected)
      this.lineActionTarget.setAttribute("aria-hidden", String(!lineSelected))
    }
    if (this.hasLineButtonTarget) {
      this.lineButtonTarget.disabled = !lineSelected
      const useDirectLink = lineSelected && this.savedMethodValue === "line" && this.hasLineDirectTarget
      this.lineButtonTarget.hidden = useDirectLink
      if (this.hasLineDirectTarget) this.lineDirectTarget.hidden = !useDirectLink
    }
  }

  addDate() {
    const input = document.createElement("input")
    input.type = "date"
    input.name = "vehicle_request[preferred_contact_dates][]"
    input.min = this.dateTargets[0]?.min || ""
    input.className = "apply-complete-preference__date-input"
    input.setAttribute("aria-label", `希望連絡日 ${this.dateTargets.length + 1}`)
    input.dataset.contactPreferenceTarget = "date"
    input.dataset.action = "change->contact-preference#refreshDates"

    const row = document.createElement("div")
    row.className = "apply-complete-preference__date-input-row"
    row.append(input)

    const removeButton = document.createElement("button")
    removeButton.type = "button"
    removeButton.className = "apply-complete-preference__remove-date"
    removeButton.dataset.action = "contact-preference#removeDate"
    removeButton.textContent = "削除"
    row.append(removeButton)

    this.dateInputsTarget.append(row)
    this.sync()
    input.focus()
  }

  removeDate(event) {
    const row = event.currentTarget.closest(".apply-complete-preference__date-input-row")
    if (!row) return

    if (this.dateInputsTarget.children.length === 1) {
      const input = row.querySelector("input")
      if (input) input.value = ""
    } else {
      row.remove()
    }

    this.refreshDates()
  }

  refreshDates() {
    if (!this.hasSelectedDatesTarget || !this.hasDateInputsTarget) return

    const dates = this.dateTargets
      .map((input) => input.value)
      .filter((value, index, values) => value && values.indexOf(value) === index)
      .sort()

    this.selectedDatesTarget.replaceChildren()

    if (dates.length === 0) {
      this.selectedDatesTarget.hidden = true
      return
    }

    this.selectedDatesTarget.hidden = false
    const label = document.createElement("span")
    label.className = "apply-complete-preference__selected-dates-label"
    label.textContent = "選択中："
    this.selectedDatesTarget.append(label)

    dates.forEach((date) => {
      const chip = document.createElement("span")
      chip.className = "apply-complete-preference__date-chip"
      chip.textContent = this.formatDate(date)
      this.selectedDatesTarget.append(chip)
    })
  }

  formatDate(value) {
    const [year, month, day] = value.split("-").map(Number)
    if (!year || !month || !day) return value

    return `${month}月${day}日`
  }
}
